import {
  IUserDetailUpdateDto,
  UserChangePasswordDto,
  UserSettingPasswordDto,
  IUserAddressCreateDto,
  IUserAddressUpdateDto,
  IUserWishListCreateDto,
} from 'dtos/user.dto';
import { IUser } from 'interfaces/user.interface';
import { IWishlist } from 'interfaces/wishlist.interface';
import _axios from 'libs/axios';

export default class UserRepository {
  constructor() {}

  /**
   * Get user profile
   * @returns
   */
  static profile(accessToken?: string) {
    return new Promise<IUser>(async (resolve, reject) => {
      try {
        // if accessToken
        if (accessToken) {
          const { data } = await _axios.get('/v1/public/profile', {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          });
          return resolve(data);
        } else {
          const { data } = await _axios.get('/v1/public/profile');
          return resolve(data);
        }
      } catch (error) {
        reject(error);
      }
    });
  }

  /**
   * update user profile
   * @returns
   */
  static updateDetail(payload: IUserDetailUpdateDto) {
    return new Promise<IUser>(async (resolve, reject) => {
      try {
        const { data } = await _axios.patch('/v1/public/profile', payload);
        return resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  }

  /**
   * Change user password
   * @param payload
   * @returns
   */
  static changePassword(payload: UserChangePasswordDto) {
    return new Promise<IUser>(async (resolve, reject) => {
      try {
        const { data } = await _axios.patch(
          '/v1/public/profile/change-password',
          payload
        );
        return resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  }

  /**
   * Setting user password
   * @param payload
   * @returns
   */
  static settingPassword(payload: UserSettingPasswordDto) {
    return new Promise<IUser>(async (resolve, reject) => {
      try {
        const { data } = await _axios.post(
          '/v1/public/profile/create-password',
          payload
        );
        return resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  }

  /**
   * Add address
   * @returns
   */
  static createAddress(payload: IUserAddressCreateDto) {
    return new Promise<IUser>(async (resolve, reject) => {
      try {
        const { data } = await _axios.post(
          '/v1/public/profile/address',
          payload
        );
        return resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  }

  /**
   * Update address
   * @param id
   * @param payload
   * @returns
   */
  static async updateAddress(id: number, payload: IUserAddressUpdateDto) {
    return new Promise<IUser>(async (resolve, reject) => {
      try {
        const { data } = await _axios.patch(
          `/v1/public/profile/address/${id}`,
          payload
        );
        return resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  }

  /**
   * Delete address
   * @param id
   * @returns
   */
  static deleteAddress(id: number) {
    return new Promise<IUser>(async (resolve, reject) => {
      try {
        const { data } = await _axios.delete(
          `/v1/public/profile/address/${id}`
        );
        return resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  }

  static async wishListCreate(body: IUserWishListCreateDto) {
    return new Promise<IWishlist>(async (resolve, reject) => {
      try {
        const { data } = await _axios.post<IWishlist>(
          '/v1/public/profile/wishlists',
          body
        );

        return resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  }

  static async wishListDelete(id: number) {
    return new Promise<IWishlist>(async (resolve, reject) => {
      try {
        const { data } = await _axios.delete(
          `/v1/public/profile/wishlists/${id}`
        );
        return resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  }
}
